export default "https://assets-v2.scaler.com/packs/images/whiteUserIcon.16f077.svg";